import { render, staticRenderFns } from "./MultipleAnswerMatrix.vue?vue&type=template&id=4f5c5443&scoped=true&"
import script from "./MultipleAnswerMatrix.vue?vue&type=script&lang=js&"
export * from "./MultipleAnswerMatrix.vue?vue&type=script&lang=js&"
import style0 from "./MultipleAnswerMatrix.vue?vue&type=style&index=0&id=4f5c5443&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5c5443",
  null
  
)

export default component.exports